import React from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import classNames from 'classnames';
import { OrderInfo } from 'common/types';

interface Props {
	rentalInfo: OrderInfo;
}
const RentalCardChannelBar = (props: Props) => {
	const { rentalInfo } = props;
	const classes = useStyles();

	const failedLink =
		(rentalInfo.rentalLink &&
			rentalInfo.rentalLink.smsDeliveryStatusHistory &&
			rentalInfo.rentalLink.smsDeliveryStatusHistory.some((event) => event.status === 'failed') &&
			!rentalInfo.rentalLink.smsDeliveryStatusHistory.some(
				(event) => event.status === 'delivered',
			)) ||
		false;

	return (
		<>
			{rentalInfo.activeState === 'PAYLINK_SENT' && failedLink ? (
				<>
					<div className={classNames(classes.bar, classes.redBar)} />
				</>
			) : rentalInfo.activeState === 'PAYLINK_SENT' ? (
				<>
					<div className={classNames(classes.bar, classes.yellowBar)} />
				</>
			) : (
				<>
					<div className={classNames(classes.bar, classes.greenBar)} />
				</>
			)}
		</>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		bar: {
			position: 'absolute',
			height: '100%',
			top: 0,
			left: 0,
			width: 6,
		},
		greenBar: {
			backgroundColor: theme.palette.success.main,
		},
		yellowBar: {
			backgroundColor: theme.palette.warning.main,
		},
		redBar: {
			backgroundColor: theme.palette.error.main,
		},
	}),
);

export default RentalCardChannelBar;
